import React from 'react';
import { Col } from '@amzn/stencil-react-components/layout';
import { Text } from '@amzn/stencil-react-components/text';
import { IconQuestionCircle } from '@amzn/stencil-react-components/icons';
import { Table } from '@amzn/stencil-react-components/table';
import { withTooltip } from '@amzn/stencil-react-components/tooltip';
import moment from 'moment';
import { useTranslation } from 'react-i18next';


import { useUserDataContext } from '../hooks';
import { ExpectedDPMOChangeEvent } from '../types/backendService';

const IconWithTooltip = withTooltip()(IconQuestionCircle);

export const ExpectedDPMOReport = ({}) => {
  const { expectedDPMOChangeEvents } = useUserDataContext();
  const { t } = useTranslation();

  const columns = [
    {
      header: t('startDate'),
      accessor: ({ data }: { data: ExpectedDPMOChangeEvent }) => moment(data.startTime! * 1000).format('M/D/Y')
    },
    {
      header: t('endDate'),
      accessor: ({ data }: { data: ExpectedDPMOChangeEvent }) => data.endTime == undefined ? '-' : moment(data.endTime! * 1000).format('M/D/Y')
    },
    {
      header: t('errorFamily'),
      accessor: 'errorFamily'
    },
    {
      header: <>{t('thresholdDpmo')} <IconWithTooltip tooltipText="The DPMO that 75% of eligible associates who worked in the process path were able to achieve in the prior month" /></>,
      accessor: 'dpmo'
    },
  ];

  if (expectedDPMOChangeEvents === undefined || expectedDPMOChangeEvents.length === 0) {
    return (
      <>
        <Text fontWeight="light">{t('noDataAvailable')}</Text>
      </>
    );
  }
  return (
    <>
      <Col>
        <Table
          columns={columns}
          data={expectedDPMOChangeEvents}
        />
      </Col>
    </>
  );

}
